export const version = "2.0-beta (edge-2-g38674bd0)";
